import React, { useEffect, useState } from "react";
import {
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  CardTitle,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import NumberFormat from "react-number-format";
import WizardError from "../../auth/register/WizardError";
import { useSelector } from "react-redux";
import { toInteger } from "lodash";

const ProfileBasic = ({
  firstname,
  lastname,
  dni,
  edit,
  property,
  wasBeEdited,
  register,
  setValue,
  errors,
}) => {
  const { role } = useSelector((state) => state.auth.user);
  const [prefix, setPrefix] = useState("V");
  const [dnia, setDniA] = useState(null);

  register("firstname");
  register("lastname");
  register("dni");

  useEffect(() => {
    if (dni) {
      setDniA(toInteger(dni.substring(1, 40)));
      setPrefix(dni.charAt(0));
    }
  }, [dni]);

  return (
    <>
      <CardBody className="pb-0">
        <CardTitle tag="h5">Información básica</CardTitle>
        <Row form>
          <Col tag={FormGroup}>
            <Label htmlFor="dni">Doc. Identidad</Label>
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <Input
                  type="select"
                  value={prefix}
                  readOnly={role === "manager" ? true : !edit}
                  disabled={role === "manager" || !edit}
                  onChange={(e) => {
                    setPrefix(e.target.value);
                    setValue("dni", `${e.target.value}${dnia}`);
                    wasBeEdited();
                  }}
                >
                  <option value="V">V</option>
                  <option value="E">E</option>
                  <option value="J">J</option>
                  <option value="P">P</option>
                  <option value="C">C</option>
                  <option value="G">G</option>
                </Input>
              </InputGroupAddon>
              <NumberFormat
                className="form-control"
                value={dnia || undefined}
                readOnly={role === "manager" ? true : !edit}
                onValueChange={({ value }) => {
                  if (!edit || role === "manager") return;
                  setDniA(value);
                  setValue("dni", `${prefix}${value}`);
                  wasBeEdited();
                }}
                thousandSeparator="."
                decimalSeparator="," 
                decimalScale={0}
                renderText={(value, props) => <div {...props}>{value}</div>}
              />
            </InputGroup>
            {errors.dni && <WizardError error={errors?.dni?.message} />}
          </Col>
        </Row>
        <Row form>
          <Col tag={FormGroup}>
            <Label htmlFor="firstname">Nombres</Label>
            <Input
              onChange={wasBeEdited}
              required={true}
              id="firstname"
              disabled={!edit}
              name="firstname"
              innerRef={register({
                pattern: {
                  value: /^[A-Za-zÁÉÍÓÚáéíóúñÑ ]+$/i,
                  message: "Ingrese un nombre válido.",
                },
              })}
              className="form-control"
              defaultValue={firstname}
            />
            <WizardError error={errors.firstname?.message} className="mt-1" />
          </Col>
          <Col tag={FormGroup}>
            <Label htmlFor="lastname">Apellidos</Label>
            <Input
              onChange={wasBeEdited}
              required={true}
              id="lastname"
              disabled={!edit}
              name="lastname"
              innerRef={register({
                pattern: {
                  value: /^[A-Za-zÁÉÍÓÚáéíóúñÑ ]+$/i,
                  message: "Ingrese un apellido válido.",
                },
              })}
              className="form-control"
              defaultValue={lastname}
            />
            <WizardError error={errors.lastname?.message} className="mt-1" />
          </Col>
        </Row>
        {role === "property" && (
          <Row form>
            <Col tag={FormGroup}>
              <Label htmlFor="house">Inmueble</Label>
              <Input
                onChange={wasBeEdited}
                /* required={true} */
                id="house"
                disabled={!edit}
                name="house"
                innerRef={register({
                  /*      pattern: {
                  value: /^[A-Za-zÁÉÍÓÚáéíóúñÑ ]+$/i,
                  message: "Ingrese un nombre válido.",
                }, */
                })}
                className="form-control"
                defaultValue={property}
              />
              <WizardError error={errors.house?.message} className="mt-1" />
            </Col>
          </Row>
        )}
      </CardBody>
    </>
  );
};

export default ProfileBasic;
